import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import AllDeviceInfo from './AllDeviceInfo';

class Payment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems : [
                { title : "Minimis", link : "/" },
                { title : "Devices", link : "#" },
            ],
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="" breadcrumbItems={this.state.breadcrumbItems} />
                        <Row>
                               <AllDeviceInfo/>
                        </Row>

                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default Payment;
